module.exports = __webpack_public_path__ + "public/SiteImages/stepDarkBg.svg?4eea0f3e";